import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchGenerateHashData } from '../../../utilities/API/caseServices'

export const generateHashData = createAsyncThunk(
    'generate/Hash', fetchGenerateHashData
)


const initialState = {
    loader: false,
}

const generateHashDataSlice = createSlice({
    name: 'generateHashData',
    initialState,

    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateHashData.pending, (state, action) => {
                state.loader = true
            })
            .addCase(generateHashData.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(generateHashData.rejected, (state, action) => {
                state.loader = false
            })
    },
})

export default generateHashDataSlice.reducer
